export enum LeadResponseType {
  OutOfArea = "out_of_area"
}
